<template>
  
  <v-dialog
    v-model   = "isOpen"
    width     = "40vw"
  >
    <v-sheet
      class     = "pa-4"
      style     = "position: relative"
    >

      <div 
        v-if  = "title"
        class = "text-h5 mb-2"
      >
        {{ title }}
      </div>

      <!-- Breadcrumbs -->
      <FileBreadCrumbs
        :path       = "files.path"
        :favorites  = "files.favorites"
        @folder     = "onFolder"
        @files      = "onFiles"
      >
      </FileBreadCrumbs>

      <!-- Files -->
      <FileList
        v-if          = "isOpen"
        :entries      = "entries"
        :path         = "files.path"
        :order        = "files.order"
        :filter       = "files.filter"
        :favorites    = "files.favorites"
        :fileActions  = "fileActions"
        @folder       = "onFolder"
        @files        = "onFiles"
        @action       = "onAction"
      >
      </FileList>

      <v-progress-linear 
        dark 
        indeterminate 
        :active     = "files.isBusy" 
        absolute 
        bottom
      >
      </v-progress-linear>

    </v-sheet>
  </v-dialog>

</template>

<script>

// #region Imports

/* vuex */
import { mapState } from 'vuex';

/* Telestream */
import FileBreadCrumbs from './filebrowser/FileBreadCrumbs';
import FileList from './filebrowser/FileList';
import {
  LIST_FILES
} from '@/utils/action-types';
import {
  SET_FILE_BROWSER_FILTER
} from '@/utils/mutation-types';

// #endregion Imports

export default {

  // #region Properties

  data() {
    return {
      title:   undefined,
      isOpen:  false,
      resolve: undefined,

      fileActions: []
    };
  },
  computed: {
    ...mapState([
      'files'
    ]),
    entries() {
      return this.files ? this.files.entries : [];
    }
  },
  components: {
    FileBreadCrumbs,
    FileList
  },

  // #endregion Properties

  // #region Methods

  methods: {

    // #region Events

    onFolder(folder) {
      this.$store.commit(SET_FILE_BROWSER_FILTER, '');
      this.$store.dispatch(LIST_FILES, folder);
      this.$emit('folder', folder);
    },

    onFiles(files) {
      this.isOpen = false;
      this.resolve(files);
    },

    onAction(event) {
      this.$emit('action', event);
    },

    // #endregion Events

    // #region Operations

    select(title, startingFolder, actions) {
      this.title = title;
      this.$store.dispatch(LIST_FILES, startingFolder);
      this.isOpen = true;
      this.fileActions = actions;

      return new Promise(resolve => this.resolve = resolve);
    }

    // #endregion Operations

  }

  // #endregion Methods

}

</script>
